module.exports = __webpack_public_path__ + "img/shi2.949bbf7b.png";